import httpRequest from 'httpRequest'
import {
    ItemCategoryContract,
    ItemCategoryLiteContract,
    KitchenCategorySortOrder,
} from 'models'

const PRODUCT_CATEGORY_PREFIX = '/company/products/categories'

const productCategoryService = {
    getProductCategoryLookupList: () =>
        httpRequest.get<ItemCategoryLiteContract[]>(
            `${PRODUCT_CATEGORY_PREFIX}/lookup-list`,
        ),
    getProductCategories: () =>
        httpRequest.get<ItemCategoryContract[]>(`${PRODUCT_CATEGORY_PREFIX}`),
    getProductCategory: (productCategoryID: string) =>
        httpRequest.get<ItemCategoryContract>(
            `${PRODUCT_CATEGORY_PREFIX}/${productCategoryID}`,
        ),
    createProductCategory: (payload: ItemCategoryContract) =>
        httpRequest.post<ItemCategoryContract>(
            `${PRODUCT_CATEGORY_PREFIX}`,
            payload,
        ),
    updateProductCategory: (
        productCategoryID: string,
        payload: ItemCategoryContract,
    ) =>
        httpRequest.put(
            `${PRODUCT_CATEGORY_PREFIX}/${productCategoryID}`,
            payload,
        ),
    deleteProductCategory: (itemCategoryIDs: string[]) =>
        httpRequest.delete(`${PRODUCT_CATEGORY_PREFIX}`, {
            params: { itemCategoryIDs },
        }),
    importProductCategory: (formData: FormData) =>
        httpRequest.post(`${PRODUCT_CATEGORY_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    syncCategoriesToKDS: () =>
        httpRequest.put(`${PRODUCT_CATEGORY_PREFIX}/sync-to-kds`, {}),
    getKitchenSortOrder: () =>
        httpRequest.get<KitchenCategorySortOrder[]>(
            `${PRODUCT_CATEGORY_PREFIX}/kitchen-sort-order`,
        ),
    updateKitchenSortOrder: (sortedCategoryIDs: string[]) =>
        httpRequest.put(
            `${PRODUCT_CATEGORY_PREFIX}/update-kitchen-sort-order`,
            sortedCategoryIDs,
        ),
}

export default productCategoryService
